import { render, staticRenderFns } from "./CreateIntegrationDatabase.vue?vue&type=template&id=752207f1&scoped=true&"
import script from "./CreateIntegrationDatabase.vue?vue&type=script&lang=js&"
export * from "./CreateIntegrationDatabase.vue?vue&type=script&lang=js&"
import style0 from "./CreateIntegrationDatabase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CreateIntegrationDatabase.vue?vue&type=style&index=1&id=752207f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752207f1",
  null
  
)

export default component.exports